import { AfterViewInit, Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { AnswerService } from 'src/app/service/answer.service';
import { QuestionService } from 'src/app/service/question.service';
import Keyboard from 'simple-keyboard';
// import layout from "simple-keyboard-layouts/build/layouts/hindi";
import KeyboardLayouts from 'simple-keyboard-layouts';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-open-end',
  templateUrl: './open-end.component.html',
  styleUrls: ['./open-end.component.scss']
})
export class OpenEndComponent implements OnInit, AfterViewInit {
  public ansBody:any = {
    question_label:'',
    question_name:'',
    answer_text:''
  }

  value = '';
  // value1 = '';

  
  @ViewChild('simpleKeyboardRef', {static:false}) simpleKeyboardRef: ElementRef | undefined;
  @ViewChild('input', {static:false}) inputRef: ElementRef | undefined;
  public keyboard: Keyboard | undefined;
  public keyboardLayouts: any;
  public isKeyboardReInstanciated : boolean =false;
  public componentType:string = "";
  layoutsObj: any;
  selectedLayout: string = 'english';
  constructor(public qService:QuestionService, 
    public aService:AnswerService,
    public notifier: NotifierService,
    private renderer: Renderer2,
    private deviceService: DeviceDetectorService ) { 
      this.keyboardLayouts = new KeyboardLayouts();
      this.layoutsObj = this.keyboardLayouts.get();
      this.componentType = this.qService.questionType.OPEN_END
      this.qService.refreshAnsBody
      .subscribe((question_type:string) =>{
        if (question_type == this.componentType) {
          this.resetAnsBody();
        }
      })
    }

  ngOnInit(): void {
  }

  next(){
    this.ansBody.question_label = this.qService.currentQuestion.question_label;
    this.ansBody.question_name = this.qService.currentQuestion.question_name;
    // var reg = new RegExp(this.ansBody.answer_text);
    this.ansBody.answer_text = this.ansBody.answer_text.trim()
    var reg = /^[0-9]*$/;
    // var reg = new RegExp(this.qService.currentQuestion.misc.regex);
    if (!this.ansBody.answer_text || this.ansBody.answer_text == '') {
      this.notifier.notify('error',"Please select a value");
      return;
    }else if (!reg.test(this.ansBody.answer_text)) {
      this.notifier.notify('error',"Please insert valid "+this.ansBody.question_label);
      return;
    }else if(this.ansBody.question_label.toLowerCase() == 'age'){
      let age = Number(this.ansBody.answer_text);
      if (!age) {
        this.notifier.notify('error',"Please insert valid "+this.ansBody.question_label);
        return;
      }else if(age > 99){
        this.notifier.notify('error',"Please insert valid "+this.ansBody.question_label);
        return;
      }
    }
    this.aService.submitAnswer(this.ansBody);
    // this.resetAnsBody();
    // setTimeout(() => {
    //   this.resetAnsBody();
    // }, 100);
  }




  ngAfterViewInit() {
    // this.keyboard = new Keyboard(".simple-keyboard",{
    //   onChange: input => this.onChange(input),
    //   onKeyPress: (button: any) => this.onKeyPress(button)
    // });

    // console.log('hello `Home` component');
    //   let deviceInfo = this.deviceService.getDeviceInfo();
    //   const isMobile = this.deviceService.isMobile();
    //   const isTablet = this.deviceService.isTablet();
    //   const isDesktopDevice = this.deviceService.isDesktop();
    //   console.log(deviceInfo);
    //   console.log(isMobile);  // returns if the device is a mobile device (android / iPhone / windows-phone etc)
    //   console.log(isTablet);  // returns if the device us a tablet (iPad etc)
    //   console.log(isDesktopDevice);
  }

  // onInputFocus() {
  //   if (this.keyboard) {
  //     this.keyboard.resetRows()
  //   }
  //   console.log(this.inputRef?.nativeElement)
  //   this.isKeyboardReInstanciated = true;
  //   console.log("this.keyboard",this.keyboard);
  //   this.keyboard = new Keyboard(".simple-keyboard",{
  //     onChange: input => this.onChange(input),
  //     onKeyPress: (button: any) => this.onKeyPress(button)
  //   });
  // }
  
  // DeChange(){
  //   this.renderer.listen('window', 'click',(e:Event)=>{
  //     if (this.simpleKeyboardRef && this.inputRef) {
  //       if(e.target !== this.simpleKeyboardRef.nativeElement && e.target !== this.inputRef.nativeElement && !this.simpleKeyboardRef.nativeElement.contains(e.target) && !this.inputRef.nativeElement.contains(e.target)){
  //         if (this.keyboard) {
  //           this.keyboard.resetRows()
  //         }
  //       }
  //     }
  //   });
  //   this.isKeyboardReInstanciated = false;
  //   console.log("focus out",this.keyboard);
  // }

  onOpenKeyboard() {
    if (this.keyboard) {
      this.keyboard.resetRows()
    }
    this.selectedLayout = 'english';
    this.isKeyboardReInstanciated = true;
    this.keyboard = new Keyboard(".simple-keyboard",{
      onChange: input => this.onChange(input),
      onKeyPress: (button: any) => this.onKeyPress(button),
      layout: {
        default: [this.layoutsObj[this.selectedLayout].layout.default][0],
        shift: [this.layoutsObj[this.selectedLayout].layout.shift][0],
        numeric: ['1 2 3', '4 5 6', '7 8 9', '{bksp} 0 {enter}'],
        decimal: ['1 2 3', '4 5 6', '7 8 9', '.00 0 .', '{bksp} {enter}'],
      },
      buttonTheme: [
        {
          class: 'hg-enter',
          buttons: '{enter}',
        },
      ],
      display: {
        '{enter}': '↩',
        '{bksp}': '⌫',
        '{space}': ' ',
        '{shift}': '⇪',
        '{lock}': '🄰',
        '{tab}': '⇄',
      },
    });

    if (this.qService.currentQuestion.misc && this.qService.currentQuestion.misc.ans_type && this.qService.currentQuestion.misc.ans_type == "numeric") {
      this.keyboard.setOptions({
        inputName: 'numericInput',
        layoutName: 'numeric',
      });
    }

    if (this.keyboard && this.ansBody.answer_text!= '') {
      this.keyboard.setInput(this.ansBody.answer_text);
    }
    // console.log("onOpenKeyboard this.keyboard",this.keyboard);
  }

  onCloseKeboard(){
    if (this.keyboard) {
      this.keyboard.resetRows()
    }
    this.isKeyboardReInstanciated = false;
  }
    
  onChange = (input: string) => {
    this.value = input;
    this.ansBody.answer_text = this.value;
  };


  onKeyPress = (button: string) => {
    if (button === '{shift}' || button === '{lock}') this.handleShift();
  };

  onInputChange = (event: any) => {
    if (this.keyboard) {
      this.keyboard.setInput(event.target.value);
    }
    this.ansBody.answer_text = event.target.value;
  }

  handleShift = () => {
    if (this.keyboard) {
      let currentLayout = this.keyboard.options.layoutName;
      console.log("this.keyboard.options.layoutName ",this.keyboard.options.layoutName)
      let shiftToggle = currentLayout === "default" ? "shift" : "default";
  
      this.keyboard.setOptions({
        layoutName: shiftToggle
      });
   
    }
  };

  resetAnsBody(){
    this.ansBody ={
      question_label:'',
      question_name:'',
      answer_text:'',
    }
  }

}
